import { useEffect, useRef } from "react";
import { ReactLenis } from "lenis/react";
import { Navbar } from "@/components/Navbar";
import { WhatsAppFab } from "@/components/WhatsAppFab";
import { Hero } from "@/components/sections/Hero";
import { Problema } from "@/components/sections/Problema";
import { Metodo } from "@/components/sections/Metodo";
import { Livelli } from "@/components/sections/Livelli";
import { Risultati } from "@/components/sections/Risultati";
import { Testimonianze } from "@/components/sections/Testimonianze";
import { ChiSono } from "@/components/sections/ChiSono";
import { Zona } from "@/components/sections/Zona";
import { Faq } from "@/components/sections/Faq";
import { Contatto } from "@/components/sections/Contatto";
import { Footer } from "@/components/sections/Footer";

export const Landing = () => {
  const lenisRef = useRef(null);

  useEffect(() => {
    const id = setInterval(() => {
      if (lenisRef.current?.lenis) {
        window.__lenis = lenisRef.current.lenis;
        clearInterval(id);
      }
    }, 60);
    return () => {
      clearInterval(id);
      window.__lenis = null;
    };
  }, []);

  return (
    <ReactLenis root ref={lenisRef} options={{ lerp: 0.08, smoothWheel: true }}>
      <div className="App">
        <Navbar />
        <main>
          <Hero />
          <Problema />
          <Metodo />
          <Livelli />
          <Risultati />
          <Testimonianze />
          <ChiSono />
          <Zona />
          <Faq />
          <Contatto />
        </main>
        <Footer />
        <WhatsAppFab />
      </div>
    </ReactLenis>
  );
};
